import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Gallery from './Gallery';
import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
